import {
  makeAutoObservable,
  observable,
  action,
  computed,
  runInAction,
  toJS,
  autorun,
  onBecomeUnobserved,
  reaction,
} from "mobx";
import { commonAxios } from "../../pages/ExperianPage/CommonAxios";
import { showAlertToast } from "../../Components/ToastComponent/AlertMessage.js";
import { CommonPathWay } from "../../Components/CommonPathWay";
class ManageUserStore {
  tableData = {
    options: [],
  };
  pageSize = 10;
  currentPage = 1;
  totalPages = 1;
  creditsExpiry = "";
  searchInput = "";
  invitePersonEmail = "";
  invitePersonName = "";
  inviteModalShow = false;
  selectedRowExpiry = null;
  labelErrorMessage = null;
  formSubmitMessageFlag = false;
  allocatedCredits = 1;
  allocateCreditsModalShow = false;
  ShowCreditModal = false;
  selectedRow = null;
  inforBarMessage = "";
  inforBarMessageFlag = false;
  removeUserModalShow = false;
  creditsExpiryModalShow = false;
  historyModalShow = false;
  activateuserModalShow = false;
  statusOfUser = "";
  handleActionLabel = "";
  userRole = "";
  revokeCredit = "";
  expiryDays= 0;
  triggerCommonLoader = false;
  selectedDate = null;
  openPicker = false;
  pickerRowId = null;       // which row's picker is open
  selectedDates = {}; 
  openPickerRowId = null;
  calendarValue = {
    startDate: new Date(
      new Date().setDate(new Date().getDate() - 7)
    ).toLocaleDateString("en-CA"),
    endDate: new Date().toLocaleDateString("en-CA"),
  };
  constructor(rootstore) {
    this.rootstore = rootstore;
    makeAutoObservable(this);
    reaction(
      () => [this.pageSize, this.currentPage, this.searchInput, this.calendarValue.startDate, this.calendarValue.endDate],
      () => {
        this.searchFunction();
      }
    );
    console.log(this.openPicker, "openPicker64");
  }
  handleManageUser = async () => {
    await this.searchFunction();
  };

   setCalendarValue = (value) => {
    this.calendarValue = value;
  };
  getuserdetails = async () => {
    try {
      const response = await commonAxios("/getProfile", "GET", {
        userId: this.UserId,
      });
      runInAction(() => {
        this.userRole = response.data.activeRole;
      });
    } catch (error) { }
  };
  searchFunction = async () => {
    try {
      const response = await CommonPathWay(
        "/team-management/list/users",
        "GET",
        {
          search: this.searchInput,
          limit: this.pageSize,
          page: this.currentPage,
          startDate: this.calendarValue.startDate,
          endDate: this.calendarValue.endDate,
        },
        {},
      );
      if (response?.data) {
        runInAction(() => {
          this.tableData = response.data;
          this.pageSize = response.data?.pagination?.limit || 10;
          this.currentPage = response.data?.pagination?.current_page || 1;
          this.totalPages = response.data?.pagination?.total_page;
        });
      }
    } catch (e) {
      console.error("User fetch failed:", e);
    }
  };

  handleCreateUser = async (e) => {
    e.preventDefault();
    const isValid =
      !this.invitePersonEmail ||
      !this.invitePersonName ||
      this.invitePersonEmail === "" ||
      this.invitePersonName === "";
    if (isValid) {
      this.setLabelErrorMessage("Please fill all the fields");
      return;
    }
    try {
      const response = await commonAxios(
        "/inviteNewMembers",
        "POST",
        {},
        {
          email: this.invitePersonEmail,
          userName: this.invitePersonName,
        }
      );
      showAlertToast({
        title: "Create User",
        message: "User Created successfully",
        type: "success",
      });
      this.setFormSubmitMessageFlag(true);
      this.setLabelErrorMessage(null);
      this.setInvitePersonEmail("");
      this.setInvitePersonName("");
      this.setInviteModalShow(false);
      this.searchFunction();
    } catch (e) {
      showAlertToast({
        title: "Create User",
        message: e?.response?.data?.error?.message,
        type: "error",
      });
    }
  };

  handleInviteUser = async (e) => {
    e.preventDefault();
    const isValid =
      !this.invitePersonEmail ||
      !this.invitePersonName ||
      this.invitePersonEmail === "" ||
      this.invitePersonName === "";
    if (isValid) {
      this.setLabelErrorMessage("Please fill all the fields");
      return;
    }
    try {
      const response = await CommonPathWay(
        "/team-management/invite/user",
        "POST",
        {},
        {
          member_email: this.invitePersonEmail,
          member_name: this.invitePersonName,
        }
      );
      
      showAlertToast({
        title: "Invite User",
        message: "User invited successfully",
        type: "success",
      });
      this.setFormSubmitMessageFlag(true);
      this.setLabelErrorMessage(null);
      this.setInvitePersonEmail("");
      this.setInvitePersonName("");
      this.setInviteModalShow(false);
      this.searchFunction();
      return response;
    } catch (e) {
      showAlertToast({
        title: "Invite User",
        message: e?.response?.data?.error?.message,
        type: "error",
      });
    }
  };
  
  handleCreditAllocation = async (e) => {
    e.preventDefault();
    try {
      const body = this.handleActionLabel === "Revoke Credit" ? {
        member_id: this.selectedRow?.user_id,
        credit: this.allocatedCredits,
        type: this.revokeCredit,
      } : {
        member_id: this.selectedRow?.user_id,
        credit: this.allocatedCredits,
        expiry: this.expiryDays,
      }
      const endpoint = this.handleActionLabel === "Revoke Credit"
        ? "/team-management/credit/revoke"
        : "/team-management/credit/allocate";
      const response = await CommonPathWay(
        endpoint,
        "POST",
        {},
        body
      );
      if (response?.success) {
        this.setLabelErrorMessage(null);
        this.setAllocateCreditsModalShow(false);
        showAlertToast({
          type: "success",
          message: this.handleActionLabel === "Revoke Credit" ? "Credit Revoked Successfully" : "Credit Allocated Successfully",
          title: this.handleActionLabel === "Revoke Credit" ? "Credit Revoked" : "Credit Allocation",
        });

        await this.handleManageUser();
      } else {
        throw new Error("Unexpected response format");
      }
    } catch (e) {
      showAlertToast({
        type: "error",
        message: e?.response?.data?.error?.message || "Something went wrong",
        title: this.handleActionLabel === "Revoke Credit" ? "Credit Revoked Failed" : "Credit Allocation Failed",
      });
    }
  };

  handleRemoveUser = async () => {
    try {
      const response = await CommonPathWay(
        `${this.handleActionLabel === 'Remove Member'} ? "/team-management/user/remove" : "/team-management/user/delete"`,
        "POST",
        {},
        {
          member_id: this.selectedRow?.user_id,
        }
      );
      showAlertToast({
        type: "success",
        message: "User Removed Successfully",
        title: "User Removal",
      });
      runInAction(() => {
        this.setRemoveUserModalShow(false);
      });
      return response;
    } catch (e) {
      showAlertToast({
        type: "error",
        message: e?.response?.data?.error?.message,
        title: "Remove User",
      });
    }
  };
  handleActivateUser = async () => {
    try {
      const response = await commonAxios(
        "/removeUser",
        "POST",
        {},
        {
          member_id: this.selectedRow?.user_id,
          status: this.statusOfUser,
        }
      );
      showAlertToast({
        type: "success",
        message: "User Activate Successfully",
        title: "User Activated",
      });
      runInAction(() => {
        this.setActivateModalShow(false);
      });
    } catch (e) {
      showAlertToast({
        type: "error",
        message: e?.response?.data?.error?.message,
        title: "User Activation",
      });
    }
  };

openPickerForRow(rowId) {
  this.openPickerRowId = this.openPickerRowId === rowId ? null : rowId;
}

  closePicker() {
    this.pickerRowId = null;
  }

  fetchCreditHistoryFinal = async () => {
   try {
      const response = await CommonPathWay(
        "/credit-management/user/histroy",
        "GET",
        {
          member_id: this.selectedRow?.user_id,
        },
        {},
      );
      runInAction(() => {
        this.creditHistory = response?.data || [];
      });
    } catch (err) {
      runInAction(() => {
        this.triggerCommonLoader = false;
      });
      console.error("Failed to fetch credits", err);
    }
  }

  handleExpiryEdit = async (date) => {
    // e.preventDefault();
    console.log(date, "date");
     const localDateString = date.toLocaleDateString('en-CA'); // 'en-CA' gives YYYY-MM-DD format
  const days = localDateString;
    const isValid =
      !date ||
      date === "";
    if (isValid) {
      this.setLabelErrorMessage("Please fill all the fields");
      return;
    }
    try {
      const response = await CommonPathWay(
        "/credit-management/expiry/edit",
        "POST",
        {},
        {
          days: days,
          credit_id: this.selectedRowExpiry?._id,
        }
      );
      showAlertToast({
        title: "Expiry Days Edit",
        message: "Expiry days edited successfully",
        type: "success",
      });
      this.setLabelErrorMessage(null);
      this.setCreditsExpiry("");
      this.setCreditsExpiryModalShow(false);
      // this.setHistoryModalShow(false);
      this.fetchCreditHistoryFinal();
    } catch (e) {
      showAlertToast({
        title: "Expiry Days Edit",
        message: e?.response?.data?.error?.message,
        type: "error",
      });
    }
  };

  handleDateChange = (rowId, date) => {
    this.selectedDates[rowId] = date;
    this.closePicker();
    this.handleExpiryEdit(this.selectedDate);
    // 🔥 Call API after selecting date
    // this.updateValidUntil(row.id, date);
    console.log(this.openPicker,this.selectedDate,  this.selectedDates[rowId], "this.openPicker");
    
  };

  handleShowcredits = async (value) => {
    try {
      const response = await CommonPathWay(
        "/team-management/credit/hide",
        "POST",
        {},
        {
          member_id: this.selectedRow?.user_id,
          hide_credit: value,
        }
      );
      showAlertToast({
        type: "success",
        message: "Show Credits status updatted",
        title: "Show Credits",
      });
      runInAction(() => {
        this.setShowCreditModal(false);
        this.handleManageUser();
      });
      return response;
    } catch (e) {
      showAlertToast({
        type: "error",
        message: e?.response?.data?.error?.message,
        title: "Show Credits",
      });
    }
  };

  fetchCreditHistory = async () => {
    console.log(this.selectedRow?.user_id, "userID");
    
    this.triggerCommonLoader = true;
    this.setHistoryModalShow(false); // hide modal until data comes

   try {
      const response = await CommonPathWay(
        "/credit-management/user/histroy",
        "GET",
        {
          member_id: this.selectedRow?.user_id,
        },
        {},
      );
      runInAction(() => {
        this.creditHistory = response?.data || [];
        this.triggerCommonLoader = false;
        this.setHistoryModalShow(true); // open modal only after data
      });
    } catch (err) {
      runInAction(() => {
        this.triggerCommonLoader = false;
      });
      console.error("Failed to fetch credits", err);
    }
  }

  handleOptionClickManageUser = (row, option) => {
    console.log(row, option, option?.label, "option");
    this.handleActionLabel = option?.label?.label || option?.label;
    if (option?.label?.label === "Hide Credit") {
      this.setShowCreditModal(true);
      this.setSelectedRow(row);
    }
    if (option?.label?.label === "Allocate Credit") {
      this.setAllocateCreditsModalShow(true);
      this.setSelectedRow(row);
    }
    if (option?.label?.label === "Remove Member") {
      this.setRemoveUserModalShow(true);
      this.setSelectedRow(row);
      this.statusOfUser = option.type;
    }
    if (option?.label?.label === "Delete User") {
      this.setRemoveUserModalShow(true);
      this.setSelectedRow(row);
      this.statusOfUser = option.type;
    }
    if (option.label === "Credit History") {
      this.setSelectedRow(row);
      this.statusOfUser = option.type;
      this.fetchCreditHistory();
    }
    if (option.label === "Credit Expiry") {
      this.setSelectedRowExpiry(row);
      this.statusOfUser = option.type;
      this.setCreditsExpiryModalShow(true);
    }
    if (option?.label?.label === "Revoke Credit") {
      this.setAllocateCreditsModalShow(true);
      this.setSelectedRow(row);
    }
  };

  handleOptionClick = (row, option) => {
    if (option.label === "Credit Visibility") {
      this.setShowCreditModal(true);
      this.setSelectedRow(row);
    }
    if (option.label === "Allocate Credit") {
      this.setAllocateCreditsModalShow(true);
      this.setSelectedRow(row);
    }
    if (option.label === "Remove User") {
      this.setRemoveUserModalShow(true);
      this.setSelectedRow(row);
      this.statusOfUser = option.type;
    }
    if (option.label === "Activate User") {
      this.setActivateModalShow(true);
      this.setSelectedRow(row);
      this.statusOfUser = option.type;
    }
  };
  setSearchInput = (value) => {
    this.searchInput = value;
  };
  setPageSize = (size) => {
    this.pageSize = size;
  };
  setCurrentPage = (page) => {
    if (page < 0) {
      this.currentPage = 0;
    } else {
      this.currentPage = page;
    }
  };
  setInvitePersonEmail = (value) => {
    this.invitePersonEmail = value;
  };
  setInvitePersonName = (value) => {
    this.invitePersonName = value;
  };
  setInviteModalShow = (value) => {
    this.inviteModalShow = value;
  };
  setLabelErrorMessage = (value) => {
    this.labelErrorMessage = value;
  };
  setFormSubmitMessageFlag = (value) => {
    this.formSubmitMessageFlag = value;
  };
  setAllocatedCredits = (value) => {
    if (value <= 0 && value !== "") {
      showAlertToast({
        type: "warning",
        title: "Credit Allocation",
        message: "Please enter greater than one",
      });
      return;
    }
    this.allocatedCredits = value;
  };

  setExpiryDays = (value) => {
    this.expiryDays = value;
  };

  setRevokeCredit = (value) => {
    this.revokeCredit = value;
  };

  setAllocateCreditsModalShow = (value) => {
    this.allocateCreditsModalShow = value;

    if (value) {
      this.allocatedCredits = 1;
    }
  };
  setShowCreditModal = (value) => {
    runInAction(() => {
      this.ShowCreditModal = value;
    })
  };
 setCreditsExpiry = (value) => {
    this.creditsExpiry = value;
  };
  setSelectedRow = (row) => {
    this.selectedRow = row;
  };
  setSelectedRowExpiry = (row) => {
    this.selectedRowExpiry = row;
  };
  setInforBarMessage = (message) => {
    this.inforBarMessage = message;
  };
  setInforBarMessageFlag = (flag) => {
    this.inforBarMessageFlag = flag;
  };
  setRemoveUserModalShow = (value) => {
    this.removeUserModalShow = value;
  };
  setCreditsExpiryModalShow = (value) => {
    this.creditsExpiryModalShow = value;
  };
  setHistoryModalShow = (value) => {
    this.historyModalShow = value;
  };
  setOpenPicker = (value) => {
    this.openPicker = value;
  };
  setSelectedDate = (date) => {
    this.selectedDate = date;
  };
  setActivateModalShow = (value) => {
    this.activateuserModalShow = value;
  };
}
export default ManageUserStore;
